class MapeadorMapaProcesso {
    toMap<T>(obj: any): Map<number, T> {
        const strMap = new Map();
        for (const k of Object.keys(obj)) {
            strMap.set(parseInt(k), obj[k]);
        }
        return strMap;
    }
}

export default new MapeadorMapaProcesso();